import {
  RecipesCoverPhotoStorageRefFromURL,
  RecipesPhotosStorage,
} from 'services/firebase';

const deleteCoverPhoto = async (recipeID, oldCoverPhotoURL) => {
  if (!recipeID) throw new Error('recipeID cannot be empty');
  if (!oldCoverPhotoURL) throw new Error('oldCoverPhotoURL cannot be empty');

  const coverPhotoRef = RecipesCoverPhotoStorageRefFromURL(oldCoverPhotoURL);
  const recipesStorage = RecipesPhotosStorage(recipeID);

  const fileName = coverPhotoRef.name;

  await recipesStorage.child(fileName).delete();
};

export default deleteCoverPhoto;
